import { render, staticRenderFns } from "./EnIyiSatis.vue?vue&type=template&id=032f5c42&scoped=true"
import script from "./EnIyiSatis.vue?vue&type=script&lang=js"
export * from "./EnIyiSatis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "032f5c42",
  null
  
)

export default component.exports